const openCollapse = (collapse: HTMLElement) => {
  collapse.style.opacity = "1";
  collapse.classList.add("open");
  collapse.style.removeProperty("height");
  collapse.style.removeProperty("opacity");
};

export default openCollapse;
